import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../../Router/all_routes";
import { Info } from "feather-icons-react/build/IconComponents";
import { useForm } from "react-hook-form";
import InputField from "../../../components/Input";
import BrandServices from "../../../../services/Brand";
import ProductServices from "../../../../services/Product";
import SelectField from "../../../components/Select";
import BayServices from "../../../../services/Bay";
import SectionServices from "../../../../services/Section";

const Form = ({ onSubmit, loading }) => {

  const route = all_routes;

  const { register, handleSubmit, formState: { errors } } = useForm();

  // *For Brands
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);

  // *For Bays
  const [bays, setBays] = useState([]);
  const [selectedBay, setSelectedBay] = useState(null);

  // *For Sections
  const [sections, setSections] = useState([]);
  const [selectedSection, setSelectedSection] = useState(null);

  // *For Products
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // *For Product Variants
  const [variants, setVariants] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(null);

  // *For Get Brands
  const getBrands = async () => {
    try {
      let params = {
        page: 1,
        limit: 50,
        active: true
      }
      const { data } = await BrandServices.getBrands(params)
      setBrands(data)
    } catch (error) {
      console.log('getBrands => error:', error)
    }
  }

  // *For Get Bays
  const getBays = async () => {
    try {
      let params = {
        page: 1,
        limit: 50,
        active: true
      }
      const { data } = await BayServices.getBays(params)
      setBays(data)
    } catch (error) {
      console.log('geBays => error:', error)
    }
  }

  // *For Get Sections
  const getSections = async () => {
    try {
      let params = {
        page: 1,
        limit: 50,
        active: true
      }
      const { data } = await SectionServices.getSections(params)
      setSections(data)
    } catch (error) {
      console.log('getSections => error:', error)
    }
  }

  // *For Get Products
  const getProducts = async () => {
    try {
      let params = {
        page: 1,
        limit: 50,
        active: true,
        brand: selectedBrand?.id
      }
      const { data } = await ProductServices.getProducts(params)
      setProducts(data)
    } catch (error) {
      console.log('getProducts => error:', error)
    }
  }

  // *For Submit Form
  const submitForm = async (formData) => {
    try {
      let obj = {
        itemId: selectedProduct?.id,
        variantId: selectedVariant?.id,
        bayId: selectedBay?.id,
        sectionId: selectedSection?.id,
        quantity: Number(formData?.quantity),
      }
      onSubmit(obj)
    } catch (error) {
      console.log('submitForm => error:', error)
    }
  }

  useEffect(() => {
    getBrands()
    getBays()
    getSections()
  }, []);

  useEffect(() => {
    if (selectedBrand?.id) {
      getProducts()
    }
  }, [selectedBrand]);

  useEffect(() => {
    if (selectedProduct?.id) {
      const variant = []
      selectedProduct?.variants?.map((item) => {
        variant.push({
          id: item?.id,
          name: Object.values(item?.attributes).join('-'),
        })
      })
      setVariants(variant)
    }
  }, [selectedProduct]);

  return (
    <form onSubmit={handleSubmit(submitForm)}>
      <div className="card">
        <div className="card-body add-product pb-0">
          <div className="mb-3">
            <div className="addproduct-icon">
              <h5>
                <Info className="add-info" />
                <span>Information</span>
              </h5>
            </div>
            <div className="row align-items-center">
              <div className="col-lg-3 col-sm-3 col-6">
                <div className="mb-3 add-product">
                  <SelectField
                    label={"Brand"}
                    options={brands}
                    selected={selectedBrand}
                    onSelect={(value) => setSelectedBrand(value)}
                    error={errors?.brand?.message}
                    register={register("brand", {
                      required: 'Please select brand.'
                    })}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-sm-3 col-6">
                <div className="mb-3 add-product">
                  <SelectField
                    disabled={selectedBrand === null}
                    label={"Product"}
                    options={products}
                    selected={selectedProduct}
                    onSelect={(value) => setSelectedProduct(value)}
                    error={errors?.product?.message}
                    register={register("product", {
                      required: 'Please select product.',
                    })}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-sm-3 col-6">
                <div className="mb-3 add-product">
                  <SelectField
                    disabled={selectedProduct === null}
                    label={"Variant"}
                    options={variants}
                    selected={selectedVariant}
                    onSelect={(value) => setSelectedVariant(value)}
                    error={errors?.variant?.message}
                    register={register("variant", {
                      required: 'Please select variant.'
                    })}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-sm-3 col-6">
                <div className="mb-3 add-product">
                  <SelectField
                    label={"Bay"}
                    options={bays}
                    selected={selectedBay}
                    onSelect={(value) => setSelectedBay(value)}
                    error={errors?.bay?.message}
                    register={register("bay", {
                      required: 'Please select bay.'
                    })}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-sm-3 col-6">
                <div className="mb-3 add-product">
                  <SelectField
                    label={"Section"}
                    options={sections}
                    selected={selectedSection}
                    onSelect={(value) => setSelectedSection(value)}
                    error={errors?.section?.message}
                    register={register("section", {
                      required: 'Please select section.'
                    })}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-sm-3 col-6">
                <div className="mb-3 add-product">
                  <InputField
                    label="Quantity"
                    error={errors?.quantity?.message}
                    register={register("quantity", {
                      required: 'Please enter product quantity.',
                    })}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-12">
        <div className="btn-addproduct mb-4">
          <Link to={route.products} className="btn btn-cancel me-2">
            Cancel
          </Link>
          <button
            type="submit"
            className="btn btn-submit"
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  );
};

export default Form;
